import { render } from "./catRepairInfo.vue?vue&type=template&id=74cf05d1"
import script from "./catRepairInfo.vue?vue&type=script&lang=js"
export * from "./catRepairInfo.vue?vue&type=script&lang=js"

import "./catRepairInfo.vue?vue&type=style&index=0&id=74cf05d1&lang=css"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__